// @flow

// #region imports
import React from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'shared/routing/withRouter';
import { bindActionCreators } from 'redux';
import Spinner from '../../../components/contentLoader/spinner';
import { verifyPhoneNumber, verifyOTP,getLoginData ,storeIsShare} from '../action/index'
import {onShareAddToCart} from '../../detail/action';
import {submitSurvey} from '../../survey/action';
import SubmitNumber from '../component/SubmitNumber';
import SubmitOTP from '../component/SubmitOTP';
import verify from '../reducer/index';
import queryString from 'query-string';
import { firstQueryValue } from 'shared/util/queryParams';

// #endregion
class Verifyontainer extends React.Component<any, any> {
  
  constructor(props) {
    super(props);
    const { location } = this.props;
    const parsed = queryString.parse(location.search);
    this.state={
        url: firstQueryValue(parsed.url),
        phoneNumber: firstQueryValue(parsed.num),
        otp:"",
        totalAmount: firstQueryValue(parsed.totalAmount),
        screen: firstQueryValue(parsed.num) !== '' ? "OTP":"NUMBER",
        acceptTerms: firstQueryValue(parsed.num) !== '' ? true: false,
        errMsgNum:"",
        errMsg:"",
        otpObject : {}
    }
  }

  componentDidMount(){
    const shareUrl = this.state.url;
    if (!shareUrl || String(shareUrl).trim() === '') {
      return;
    }
    const p = this.props.getLoginData(shareUrl);
    if (p != null && typeof p.then === 'function') {
      p.catch(() => {});
    }
  }

  handleChangePhoneNumber(value) {
    this.setState({
        phoneNumber:value,
        errMsg:"",
        errMsgNum:""
    });
  }

  handleChangeOTP(value) {
    this.setState({
        otp:value,
        errMsg:""
    });
  }

  acceptTermsAndCondition() {
    this.setState({
      acceptTerms:!this.state.acceptTerm,
      errMsg:"",
    });
  }

  submitNumberToGetOTP() {
    const { phoneNumber , acceptTerms} = this.state
    if(acceptTerms &&  phoneNumber && phoneNumber.length >= 10){
      this.props.verifyPhoneNumber({"Mobile":phoneNumber,"RequestUrl" : this.props.requestUrl})
      .then((resp)=>{
        if (resp.value.data.Status == 1 && resp.value.data.Key !== "" && resp.value.data.Key !== null){
          this.setState({
            otpObject:resp.value.data,
            screen:"OTP",
            errMsg:""})
        }else{
          this.setState({
            errMsg:resp.value.data.ErrorMessage
          })
        }
      })
      .catch(function (err) {
        console.log(err)
      }.bind(this));
    }else if(phoneNumber && phoneNumber.length < 10){
      this.setState({errMsgNum:"Enter valid mobile number", screen:"NUMBER"})
    }else if(!acceptTerms){
      this.setState({errMsg:"Accept Terms and Condition"})
    }
  }

  verifyOTP() {
    this.state.otpObject.CustomerOtp =  this.state.otp
    this.props.productDetail;
    if(this.state.otp.length >= 6){
      this.props.verifyOTP(this.state.otpObject)
      .then((resp)=>{
        if(resp.value.data !== ""){
          if (resp.value.data.Status ==1){
            if(resp.value.data.IsValidShare){
              const { location } = this.props;
              
              const parsed = queryString.parse(location.search);
              const urlParam = encodeURIComponent(firstQueryValue(parsed.url));
              const payHash = encodeURIComponent(String(resp.value.data.ValidCheckHash ?? ''));
              var search =
                '?ath=true&share=true&uid=' +
                encodeURIComponent(String(resp.value.data.CustomerKey ?? '')) +
                '&url=' +
                urlParam +
                '&PaymentHashToRedirctPaymentGate=' +
                payHash;
              if(resp.value.data.ScreenRedirection == 0){
                //this.props.history.replace({pathname:"/thankYou"}) // * Coupen is free detail scrren
                if(resp.value.data.IsAddAddress){
                  window.location.href = "/address" + search
                }else{
                  window.location.href = "/thankYou"
                }
              }else if(resp.value.data.ScreenRedirection == 1){
                // this.props.history.replace({ // * For Paid Coupen  detail screen
                //   pathname: '/pay',
                //   search
                // })
                
                if(resp.value.data.IsAddAddress){
                window.location.href = "/address" + search
                }else{
                window.location.href = "/pay" + search + "&totalAmount="+this.state.totalAmount;;
                }

              }else if(resp.value.data.ScreenRedirection == 2){
                // this.props.history.replace({pathname:"/thankYou"}) //* for survey screen 
                window.location.href = "/thankYou"
              }
              this.props.storeIsShare(true);
            }
          }else {
            this.setState({errMsg:"Please enter valid OTP"})
          }
        }else {
          this.setState({errMsg:"Enter valid OTP"})
        }
      })
      .catch(function (err) {
        console.log(err)
      }.bind(this));
      this.setState({errMsg:""})
    }else if(this.state.otp.length < 6){
      this.setState({errMsg:"Enter valid OTP"})
    }
  }

  resendOTP() {
    this.submitNumberToGetOTP()
  }

  changePhoneNumber(){
    this.setState({screen:"NUMBER", errMsg:""})
  }

  render() {
    const {isLoading} = this.props;
    return (
     <div className="Main-container">
   
        {this.state.screen === "NUMBER" ? 
         <SubmitNumber 
         senderDetail = {this.props.senderDetails}
         phoneNumber={this.state.phoneNumber} 
         acceptTerms={this.state.acceptTerm}
         errMsg={this.state.errMsg}
         errMsgNum={this.state.errMsgNum}
         handleChangePhoneNumber={this.handleChangePhoneNumber.bind(this)}
         submitNumberToGetOTP={ this.submitNumberToGetOTP.bind(this) }
         acceptTermsAndCondition={this.acceptTermsAndCondition.bind(this)}/>
         :
         <SubmitOTP otp={this.state.otp} 
         phoneNumber={this.state.phoneNumber} 
         errMsg={this.state.errMsg}
         handleChangeOTP={this.handleChangeOTP.bind(this)}
         verifyOTP={this.verifyOTP.bind(this)}
         resendOTP={this.resendOTP.bind(this)}
         changePhoneNumber={this.changePhoneNumber.bind(this)}
         />
        }
        {isLoading ?  <Spinner /> : null }

    </div>
    );
  }
}

// #region redux map state and dispatch to props
const mapStateToProps = state => {
  return {
    verify:state.verify,
    senderDetails:state.verify.senderDetails,
    isLoading:state.verify.isLoading,
    productDetail : state.verify.productDetail,
    surveyData : state.verify.surveyData,
    requestUrl :state.verify.requestUrl,
  };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(
      {
        verifyPhoneNumber,
        verifyOTP,
        getLoginData,
        storeIsShare,
        onShareAddToCart,
        submitSurvey,
      },
      dispatch
    );
  };

// #endregion

export default compose(
  connect(mapStateToProps, mapDispatchToProps),withRouter
)(Verifyontainer);
